// Endpoint unificado /algorithm/rules — não força algoritmo (algorithm_keys vem
// do payload) e aceita ?algorithm_key= para filtrar a listagem por tela.
export default {
  // Interpretação em linguagem natural: GET pergunta se o atalho está
  // disponível para a instituição, POST devolve o rascunho. Nenhum dos dois
  // grava — quem grava é o `store` abaixo.
  interpretStatus: { method: 'get', url: 'algorithm/rules/interpret' },
  interpret: { method: 'post', url: 'algorithm/rules/interpret' },
  index: { method: 'get', url: 'algorithm/rules' },
  show: { method: 'get', url: 'algorithm/rules/{id}' },
  store: { method: 'post', url: 'algorithm/rules' },
  update: { method: 'put', url: 'algorithm/rules/{id}' },
  duplicate: { method: 'post', url: 'algorithm/rules/{id}/duplicate' },
  toggle: { method: 'post', url: 'algorithm/rules/{id}/toggle' },
  destroy: { method: 'delete', url: 'algorithm/rules/{id}' },
}
